import { render, staticRenderFns } from "./ChatTab.vue?vue&type=template&id=2bcc3398&"
import script from "./ChatTab.vue?vue&type=script&lang=ts&"
export * from "./ChatTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports